import { render } from "./ArtComments.vue?vue&type=template&id=0d21fac2"
const script = {}

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__